// Panels specifically for Weave Python, these are not
// production ready, which is why we separate this file

import {Spec as RunSpec} from './PanelRun';
import {Spec as PanelAnyObj} from './PanelAnyObj';
// import {Spec as PanelAuto} from './PanelAuto';
import {Spec as PanelGpt3Model} from './PanelGpt3Model';
import {Spec as PanelStringEditor} from './PanelStringEditor';
import {Spec as PanelTextEditor} from './PanelTextEditor';
import {Spec as PanelPanel} from './PanelPanel';
import {Spec as PanelSlider} from './PanelSlider';
import {Spec as PanelRef} from './PanelRef';
import {Spec as PanelObjectPicker} from './PanelObjectPicker';
import {Spec as PanelQuery} from './PanelQuery';
import {Spec as PanelFunctionEditor} from './PanelFunctionEditor';
import {Spec as PanelNewImage} from './PanelNewImage';
import {Spec as PanelStringHistogramWeave} from './PanelStringHistogramWeave';
import {Spec as PanelLabeledItem} from './PanelLabeledItem';
import {Spec as PanelEach} from './PanelEach';
import {Spec as PanelEachColumn} from './PanelEachColumn';
import {Spec as PanelGroup} from './PanelGroup';
import {Spec as PanelCard} from './PanelCard';
import {Spec as PanelWeaveLink} from './PanelWeaveLink';
import {Spec as PanelPlotly} from './PanelPlotly';
import {Spec as PanelColor} from './PanelColor';
import {Spec as PanelLayoutFlow} from './PanelLayoutFlow';
import {Spec as PanelLayoutBank} from './PanelLayoutBank';
import {Spec as PanelFacetTabs} from './PanelFacetTabs';
import {Spec as PanelSections} from './PanelSections';

export const weavePythonPanelSpecs = () => {
  return [
    RunSpec,
    PanelAnyObj,
    // PanelAuto doens't route config updates correctly and breaks stuff.
    // Don't need it yet anyway
    // PanelAuto,
    PanelGpt3Model,
    PanelStringEditor,
    PanelTextEditor,
    PanelPanel,
    PanelSlider,
    PanelRef,
    PanelObjectPicker,
    PanelQuery,
    PanelFunctionEditor,
    PanelNewImage,
    PanelStringHistogramWeave,
    PanelLabeledItem,
    PanelEach,
    PanelEachColumn,
    PanelGroup,
    PanelCard,
    PanelWeaveLink,
    PanelPlotly,
    PanelColor,
    PanelLayoutFlow,
    PanelLayoutBank,
    PanelFacetTabs,
    PanelSections,
  ];
};
